import React, { useCallback } from 'react'
import { normalize } from './utils/Normalize'
import Form from './Form'
import { ValueProvider } from './ValueContext'
import { observer } from 'mobx-react-lite'
import { SchemaProps } from '@evertel/types'

interface DocumentProps {
    layout: 'full' | 'pdf'
    schema: SchemaProps
    documentId?: number
    schemaId?: number
    value?: unknown
    onChange?: (value: Record<string, any>) => void
    errors?: Record<string, any>
    /** Field ids whose value differs from the version being compared against (Version History). */
    changedFieldIds?: Set<string>
}

const DEFAULT_VALUE = {}

const Document: React.FC<DocumentProps> = (({
    layout = 'full',
    schema,
    value = DEFAULT_VALUE,
    onChange,
    errors,
    ...otherProps
}) => {

    const normalizedSchema = normalize(schema)

    const handleChange = useCallback((_, changedValue) => {
        onChange && onChange(changedValue)
    }, [onChange])

    return (
        <ValueProvider value={value as any}>
            <Form
                id="_root"
                items={normalizedSchema.layouts[layout] as any}
                value={value}
                errors={errors}
                onChange={handleChange}
                {...otherProps}
            />
        </ValueProvider>
    )
})

export default Document
